import "./style.css"
const Footer = () => {
    return (
        <footer className="footer">
            <a
                href="https://www.linkedin.com/in/dhritesh-patel-37a225150/"
                target="_blank"
            >
                <img
                    src="https://github.com/DwinaTech/public-images/blob/main/linkedin-icon.png?raw=true"
                    alt="LinkIn-icon"
                />
            </a>
            <a
                href="https://www.youtube.com/channel/UCL4bJO3pa1crG-_8BsLPFUw"
                target="_blank"
            >
                <img
                    src="https://github.com/DwinaTech/public-images/blob/main/facebook-con.png?raw=true"
                    alt="YouTube-icon"
                />
            </a>
            <a
                href="https://twitter.com/dhritesh_patel"
                target="_blank"
            >
                <img
                    src="https://github.com/DwinaTech/public-images/blob/main/twitter-icon.png?raw=true"
                    alt="Twitter-icon"
                />
            </a>
            <a
                href="https://www.facebook.com/dhritesh1"
                target="_blank"
            >
                <img
                    src="https://github.com/DwinaTech/public-images/blob/main/youtube-icon.png?raw=true"
                    alt="Facebook-icon"
                />
            </a>
        </footer>
    )
}

export default Footer
